import * as React from 'react';

const HeadlineSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="headline_svg__eds-icon--headline_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="headline_svg__eds-icon--headline_base"
            fill="#010101"
            d="M3 22h1.3V12h11.5v10h1.3V2h-1.3v8.8H4.3V2H3v20z"
        />
        <path
            id="headline_svg__eds-icon--headline_number"
            fill="#010101"
            d="M22.5 8v-.9h-3c.1-.4.6-.9 1.5-1.5 1.1-.7 1.4-1.3 1.4-2 0-1-.7-1.7-1.9-1.7-1 0-1.7.5-2.2 1.3l.7.5c.4-.6.9-.9 1.4-.9.6 0 .9.3.9.9s-.4.9-1.3 1.5c-1.6 1-1.9 1.8-1.9 2.7V8h4.4z"
        />
    </svg>
);

HeadlineSvg.displayName = 'HeadlineSvg';
export default HeadlineSvg;
